import * as types from './mutation_types'

export default {
  [types.POST_DELETE_SET_DELETED] (state, deleted) {
    Object.assign(state, { deleted })
  },

  [types.POST_DELETE_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.POST_DELETE_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.POST_DELETE_RESET] (state) {
    Object.assign(state, {
      deleted: null,
      error: '',
      isLoading: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/post/delete/mutations.js